export default __webpack_public_path__ + "static/media/soutien_v_fr.733a9291.jpg";